import { useSelector, useDispatch } from "react-redux";
import { IStore, IAvailabilityStepInfo, Step } from "../../DataTypes/storeTypes";
import { moveNext, moveBack } from "../../Actions/actions";
import { EnumValues } from "../../../Common/enumHelper";
import { Button } from "@powerdiary/components-library/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from "react";

export const Navigation = () => {
    const {
        stepsInfo,
        common: { currentStep },
    } = useSelector((state: IStore) => state);
    const dispatch = useDispatch();

    const values = useMemo(() => EnumValues.getValues(Step), []);

    const last = values[values.length - 1];
    const currentSelected = stepsInfo[currentStep].id;

    let canMoveNext = currentSelected && currentStep < Number(last);
    let canMoveBack = currentStep > Number(values[0]);

    if (currentStep === 3) {
        const info = stepsInfo[Step.When] as IAvailabilityStepInfo;

        canMoveBack = true;
        canMoveNext = info.slot !== undefined && info.slot !== null;
    }

    return (
        <div className="row">
            <div className="col-12 d-flex justify-content-between">
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => dispatch(moveBack())}
                    disabled={!canMoveBack}
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                >
                    Previous
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => dispatch(moveNext())}
                    disabled={!canMoveNext}
                    endIcon={<FontAwesomeIcon icon={faArrowRight} />}
                >
                    Next
                </Button>
            </div>
        </div>
    );
};
